import React, {useContext} from "react";
import {styled} from '@mui/material/styles';
import {Divider, List, ListItem, Paper, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import {LanguageContext} from "../context/LanguageContext";
import {footerElementList, mainPageFooterElementList} from "../utils/constants/footer";
import invitechNewLight from "../assets/images/ic_white_small.png";
import {PersonOutline} from "@mui/icons-material";

const PREFIX = 'Footer';

const classes = {
  content: `${PREFIX}-content`,
  link: `${PREFIX}-link`,
  image: `${PREFIX}-image`
};

const StyledPaper = styled(Paper)((
  {
    theme
  }
) => ({
  [`& .${classes.content}`]: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    position: "absolute"
  },

  [`& .${classes.link}`]: {
    padding: 20
  },

  [`& .${classes.image}`]: {
    height: 20
  }
}));

const drawerWidth = 240;

const Footer = () => {

  const langContext = useContext(LanguageContext);

  return (
    <StyledPaper square elevation={0}>

    </StyledPaper>
  );

};

export default Footer;
